
import React from 'react'
import { Modal, Button } from 'react-bootstrap'

import { DemandOptions, ReportAggregateOptions } from '../../pages/Reports/ReportHelpers';
import ReportDropdownObject from './ReportDropdownObject';
import { getUserPreference } from '../../helpers/user-preferences';

export default function ReportAdvancedOptionsModal(props) {
  const { show, onHide, optionsList, payload, updatePayload } = props;

  return <Modal show={show} onHide={onHide} size='md'>
    <Modal.Header closeButton>Advanced Report Options</Modal.Header>
    <Modal.Body>
      {
        optionsList.includes('aggregate_meters') &&
        <ReportDropdownObject
          updatePayload={updatePayload}
          payload_key={'aggregate'}
          values={ReportAggregateOptions}
          defaultValue={getUserPreference('aggregate_meters')}
          label={'Aggregate Meters'}
          key_option={'index'}
          set_user_preference={true}
          user_preference_key={'aggregate_meters'}
        />
      }
      {
        optionsList.includes('demand_option') &&
        <ReportDropdownObject
          updatePayload={updatePayload}
          payload_key={'demand_option'}
          values={DemandOptions}
          defaultValue={Object.keys(payload).includes('demand_option') ? payload['demand_option'] : 0}
          label={'Demand Option'}
          key_option={'index'}
        />
      }
    </Modal.Body>
    <Modal.Footer>
      <Button
        className='float-right ml-3'
        onClick={() => onHide()}
      >
        {' '}
        Close
      </Button>
    </Modal.Footer>
  </Modal>

}
